import { ePermissions } from '../../../types/administration/userAdministration/ePermissions';
import React from 'react';
import { PermissionWrapper } from '../../accessControl/PermissionWrapper';
import { ErrorMessageTW } from '../../../tailwindComponents/errorMessage/ErrorMessageTW';
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { IHasTestData } from '../../../ui-toolkit/test-utilities/IHasTestData';
import { SimpleGrid } from '../../../tailwindComponents/grid/SimpleGrid';
import { CardTW } from '../../../tailwindComponents/CardTW/CardTW';
import { HeaderText3TW } from '../../../tailwindComponents/HeaderTextTW/HeaderTextTW';
import { AddFeatureXButton } from './subComponents/AddFeatureXButton';
import { HintTextTW } from '../../../tailwindComponents/formCellTW/HintTextTW';

interface TitleComponentProps {
  title: string;
  hintText: string;
  handleAddClick?: () => void;
  buttonText?: string;
}

interface FeaturePresentationCardProps extends IHasTestData, TitleComponentProps {
  featureFetchError?: FetchBaseQueryError | SerializedError;
  children: React.ReactNode;
}

export const FeaturePresentationCard: React.FC<FeaturePresentationCardProps> = ({
  children,
  featureFetchError,
  title,
  hintText,
  handleAddClick,
  buttonText,
  ...rest
}) => {
  return (
    <PermissionWrapper allowedPermissions={[ePermissions.FeatureRead]}>
      <ErrorMessageTW rtkError={featureFetchError} />
      <SimpleGrid data-test-id={rest['data-test-id']}>
        <CardTW>
          <TitleComponent title={title} hintText={hintText} handleAddClick={handleAddClick} buttonText={buttonText} />
          {children}
        </CardTW>
      </SimpleGrid>
    </PermissionWrapper>
  );
};

const TitleComponent: React.FC<TitleComponentProps> = ({ title, hintText, handleAddClick, buttonText }) => {
  const hasAddButton = handleAddClick && buttonText;
  return (
    <div className={'flex h-20 flex-row justify-between py-4'}>
      <div>
        <HeaderText3TW>{title}</HeaderText3TW>
        <HintTextTW hintText={hintText} />
      </div>
      {hasAddButton && <AddFeatureXButton handleAddClick={handleAddClick} buttonText={buttonText} />}
    </div>
  );
};
